<template>
  <div class="order-table">
    <el-table :data="orderDetailTableData" border style="width: 100%">
      <el-table-column type="index" label="序号" width="50"> </el-table-column>
      <el-table-column prop="order_number" label="子订单号" width="140">
      </el-table-column>
      <el-table-column prop="ruigu_code" label="锐锢编码"> </el-table-column>
      <el-table-column prop="self_code" label="三方商品编码"> </el-table-column>
      <el-table-column prop="name" label="商品名" width="280">
      </el-table-column>
      <el-table-column prop="spec" label="规格"> </el-table-column>
      <el-table-column prop="unit" label="单位"> </el-table-column>
      <el-table-column prop="total_price" label="订单金额"> </el-table-column>
      <el-table-column prop="price" label="单价"> </el-table-column>
      <el-table-column prop="amount" label="订购数量"> </el-table-column>
      <el-table-column prop="send_amount" label="实发数量"> </el-table-column>
      <el-table-column prop="mo_statusName" label="状态"> </el-table-column>
      <el-table-column prop="refuse_msg" label="申请备注" width="160">
      </el-table-column>
      <el-table-column label="操作" fixed="right">
        <!-- mo_status 主单子的状态 status 子单子的状态 -->
        <template slot-scope="scope">
          <div v-if="shopIds.indexOf(shop_id) > -1">
            <!-- <div> -->
            <!-- 紧固件 已备货也可以拒单 -->
            <el-button
              v-if="isJgj"
              type="text"
              @click="showDialog(scope.row)"
              :disabled="
                scope.row.mo_status !== '3' ||
                  scope.row.status !== '1' ||
                  !scope.row.is_enable_refuse
              "
              >申请拒单</el-button
            >
            <!-- 2023-01-30修改：【平台/工厂/直发】—— 状态=备货中时，可以拒单 -->
            <el-button
              v-else
              type="text"
              @click="showDialog(scope.row)"
              :disabled="
                scope.row.mo_status !== '2' ||
                  scope.row.status !== '1' ||
                  !scope.row.is_enable_refuse
              "
              >申请拒单</el-button
            >
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column show-overflow-tooltip prop="box_codes" label="箱码" width="280">
      </el-table-column> -->
    </el-table>

    <el-dialog
      :visible.sync="orderRefuseVisible"
      :append-to-body="true"
      :title="dialogTitle"
      width="430px"
      class="refuse-dialog"
      :show-close="false"
      ><div slot="title" class="dialog-title">
        <div v-html="dialogTitle" class="title"></div>
      </div>
      <el-form
        :model="refuseForm"
        :rules="rules"
        ref="refuseForm"
        label-width="76px"
        :inline="true"
        class="refuse-form"
      >
        <div class="fs-12">
          <span style="color:red">*</span
          >注意：拒单申请提交后需依据客服沟通结果来确认是否需要继续履约
        </div>
        <el-form-item label="来源单号" prop="orderNo">
          <el-input v-model="refuseForm.orderNo" disabled></el-input>
        </el-form-item>
        <el-form-item label="拒单原因" prop="code">
          <el-select
            v-model="refuseForm.code"
            clearable
            placeholder="请选择拒单原因"
            prop="code"
          >
            <el-option
              v-for="(item, index) in refuseMap"
              :key="index + 1"
              :label="item"
              :value="index + 1"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="原因描述"
          v-if="refuseForm.code === 5"
          prop="msg"
          class="m-t-10"
        >
          <el-input
            type="textarea"
            v-model="refuseForm.msg"
            placeholder="请输入..."
            prop="msg"
            maxlength="30"
            show-word-limit
            :autosize="{ minRows: 2, maxRows: 4 }"
            style="margin-top: 8px;"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('refuseForm')" size="mini"
          >取 消</el-button
        >
        <el-button type="primary" @click="submitForm('refuseForm')" size="mini"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { refuseOrder, jgjRefuseOrder } from "@/models/orderModel";
export default {
  props: ["orderDetailTableData"],
  data() {
    return {
      shop_id: localStorage.getItem("shop_id"),
      isJgj: localStorage.getItem("is_jgj") === "1",
      row: {},
      dialogTitle: "申请拒单",
      orderRefuseVisible: false,
      refuseForm: { orderNo: undefined, code: undefined, msg: undefined },
      refuseMap: ["无货", "客户地址盲区", "不达起订金额", "疫情影响", "其他"],
      rules: {
        orderNo: [{ required: true, trigger: "blur" }],
        code: [
          { required: true, message: "请选择拒单原因！", trigger: "change" }
        ],
        msg: [
          { required: true, message: "请输入拒单描述！", trigger: "blur" },
          { max: 30, message: "描述不能超过30个字符！", trigger: "change" }
        ]
      },
      shopIds: [
        "4",
        "79",
        "94",
        "104",
        "137",
        "161",
        "183",
        "219",
        "251",
        "446",
        "456",
        "457",
        "460"
      ]
    };
  },
  methods: {
    async refuseOrder(code, msg) {
      const row = this.row;
      let params = {
        id: row.id,
        code,
        msg
      };
      // console.log("params:", params);
      let data;
      if (this.isJgj) {
        data = await jgjRefuseOrder(params);
      } else {
        data = await refuseOrder(params);
      }

      if (data.message === "Success") {
        this.$message.success("拒单成功");
        row.mo_statusName = "已拒单";
        row.status = "-2";
        let orderData = this.orderDetailTableData.filter(
          item => item.status !== "-2"
        );
        if (orderData.length === 0) {
          this.$emit("updateOrder");
        }
        this.hideDialog("refuseForm");
      }
    },
    showDialog(row) {
      // console.log("row:", row);
      this.row = row;
      this.refuseForm.orderNo = row.order_number;
      this.$nextTick(() => {
        this.orderRefuseVisible = true;
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const { code, msg } = this.refuseForm;
          const message = code === 5 ? msg : this.refuseMap[code - 1];
          this.refuseOrder(code, message);
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$message({
        type: "info",
        message: "已取消申请拒单"
      });
      this.orderRefuseVisible = false;
      this.$refs[formName].resetFields();
    },
    hideDialog(formName) {
      this.orderRefuseVisible = false;
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style lang="scss">
.order-table {
  .el-table {
    .el-button {
      color: red;
    }
    .el-button.is-disabled {
      color: #c0c4cc !important;
    }
  }
}
.refuse-dialog {
  .title {
    // color: white;
    font-size: 16px;
  }
  .m-t-10 {
    margin-top: 10px;
  }
  .refuse-form {
    margin-top: -20px;
    .fs-12 {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bigorder/order-detail-table.vue